import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SetSession } from "../../EnvConfig/env_config";


export const login = createAsyncThunk(
    'login',
    async (data, thunkAPI) => {
        try {
            let res = await fetch('/api/UserLogin/Login', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.json()
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const getUserCompanyList = createAsyncThunk(
    'getUserCompanyList',
    async (data, thunkAPI) => {
        try {
            let res = await fetch('/api/UserLogin/Login', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.json()
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);


const initialState = {
    status: false,
    userData: null,
    Authenticated:false,
    user: null,
    userCode: null,
    token: null,
    loginSessionID: null,
    isMultipleCompanyAccess: null,
    isFranchiseeEmployee: null,
    error: null,
    loading: false,
};


const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        isAuthenticate: (state, action) => {
            state.Authenticated = action.payload
        },
        setIsMultipleCompanyAccess: (state, action) => {
            state.Authenticated = action.payload
        },
        UserLogin: (state, action) => {
            state.status = true;
            state.userData = action.payload;
        },

        LogOut: (state, action) => {
            state.status = false;
            state.userData = null;
        }, 
        setSubLoading: (state, action) => {
            state.loading = action.payload;
        }
    },
    extraReducers: (builder) => {                                          
        builder.addCase(login.fulfilled, (state, action) => {
            state.user = action.payload
            state.userCode = action.payload.eCode
            state.status = action.payload.status === "SUCCESS" ? true : false;
            state.loginSessionID = action.payload.loginSessionID
            state.isMultipleCompanyAccess = action.payload.isMultipleCompanyAccess
            state.isFranchiseeEmployee = action.payload.isFranchiseeEmployee
            SetSession('cookies', 'user', JSON.stringify(action.payload)) // Set data to Cookies Storage for Futher use
            SetSession('cookies', 'loginSessionID', action.payload.loginSessionID) // Set data to Cookies Storage for Futher use
            state.loading = false;
        })
            .addCase(login.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(login.rejected, (state, action) => {
                state.error = action.payload
                state.loading = false;
            })
            
    }

});

export const { LogOut, UserLogin, isAuthenticate, setIsMultipleCompanyAccess, setSubLoading } = authSlice.actions

export default authSlice.reducer